import React, { useContext } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { DashboardContext } from "../contexts/DashboardContext";

export default function DocumentVerificationChart() {
  const { docsData } = useContext(DashboardContext);

  if (!docsData) return null;

  return (
    <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col h-[340px] w-full">
      <h3 className="text-sm font-bold text-slate-800 mb-2">
        Document Verification
      </h3>

      <div className="grid grid-cols-2 items-center flex-1 w-full gap-2">
        {/* Left Side: Fixed Square Donut Container so it never distorts */}
        <div className="relative w-full h-[240px] flex items-center justify-center">
          <PieChart width={150} height={150}>
            <Pie
              data={docsData.data}
              cx="50%"
              cy="50%"
              innerRadius={50}
              outerRadius={70}
              paddingAngle={2}
              dataKey="value"
              stroke="none"
            >
              {docsData.data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>

          {/* Centered Donut Text */}
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
            <span className="text-xl font-bold text-slate-900 leading-none">
              {docsData.total}
            </span>
            <span className="text-[11px] text-slate-500 font-medium mt-0.5">
              Total
            </span>
          </div>
        </div>

        {/* Right Side: Clean Legend List */}
        <div className="flex flex-col justify-center gap-2.5">
          {docsData.data.map((item, index) => (
            <div key={index} className="flex flex-col text-[11px]">
              <div className="flex items-center gap-1.5 min-w-0 mb-0.5">
                <span
                  className="w-2.5 h-2.5 rounded-full shrink-0"
                  style={{ backgroundColor: item.color }}
                ></span>
                <span className="text-slate-700 font-medium truncate">
                  {item.name}
                </span>
              </div>
              <div className="pl-4 text-slate-500 text-[10px]">
                {item.value}{" "}
                <span className="text-slate-400">({item.percentage})</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
